import { Flex, SegmentedControl, Text } from '@mantine/core';
import { StepProps } from 'src/UI/drawer-flow/DrawerFlow';
import { ReportData, ReportFormat } from '../SuitabilityFlow';
import SelectSuitabilityReportTemplateStep from 'src/UI/drawer-flow/SelectSuitabilityReportTemplateStep';

export default function SuitabilitySelectTemplateStep(props: StepProps<ReportData>) {
  const { data, setData } = props;

  return (
    <SelectSuitabilityReportTemplateStep
      {...props}
      type="SUITABILITY_REPORT"
      renderExpandedContent={() => (
        <Flex direction="column" gap="xs">
          <Text size="sm" fw={500} c="gray.8">
            Report format
          </Text>
          <SegmentedControl
            value={data.reportFormat}
            onChange={value => setData({ ...data, reportFormat: value as ReportFormat })}
            data={[
              { label: 'Letter', value: 'LETTER' },
              { label: 'Report', value: 'REPORT' },
            ]}
            fullWidth
          />
          <Text size="xs" c="gray.6">
            {data.reportFormat === 'LETTER'
              ? "Make sure the client's address is set in their profile"
              : 'Report includes a title page and table of contents'}
          </Text>
        </Flex>
      )}
    />
  );
}
